// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"07db2441","213":"cd504bd1","453":"cb3ba480","455":"3dacadc5","687":"a9f9b4e2"}[chunkId] + ".chunk.js";
};